import { cva } from '@/styled-system/css';

export const switchRootRecipe = cva({
  base: {
    'display': 'inline-block',
    'lineHeight': '0',
    'position': 'relative',
    'cursor': 'pointer',

    // FOCUSED
    '& > [data-c11n-component="Switch.Input"]:focus-visible + [data-c11n-component="Switch.Track"]':
      {
        boxShadow: 'focus',
      },
  },
});
